import React, { Component, createRef } from 'react';
import { List, Grid, Button } from 'semantic-ui-react';
import { Link, useParams } from 'react-router-dom';
// import fuzzysort from 'fuzzysort';
// import axios from 'axios';
import { API_URL } from '../App.js';
// import { YugtunLoader, WordItem, TagColors } from './HomeHelper.js';
import { customFontFam3, customTitleFontFam3, customFirefoxTitleFontFam } from './constants/constants.js';
// import { sanitize } from 'dompurify';
// import {categories} from './constants/categories.js';
// import {categoriesUrlLookup} from './constants/categoriesUrlLookup.js';
import Citation from './Citation.js'


import * as Scroll from 'react-scroll';
// import { Events, animateScroll as scroll, scrollSpy, scroller } from 'react-scroll'
import ReactGA from "react-ga4";
ReactGA.initialize("G-BCN5V0JQN1")

var scroll    = Scroll.animateScroll;

let pdfLinks = {
  '1':'Common_Concerns_About_Seeking_Mental_Health_Care-Penggarutai_Yuallerkam_Umyualiuryaraamek.pdf',
  '2':'Common_Reasons_For_Seeking_Behavioral_Health_Care-Behavioral_Health_Care-aamun_Ikayungcaryarat.pdf',
  '3':'Terms_Related_To_Emotional_States-Aperyarat_Umyuamun_Tusngalriit.pdf',
  '4':'Terms_Related_To_Cognition_And_Awareness-Umyuartuyaaram_Ellangqerrsaram-llu_Aperyarai.pdf',
  '5':'Terms_Related_To_Coping_And_Recovery-Aperyarat_Auluksaramun_Utumariyaramun-llu.pdf',
  '6':'Social_And_Cultural_Aspects-Yuucim_Yuuyaram-llu_Ayuquciit.pdf',
  '7':'Treatment_And_Goals-Yuungcaryaraq_Egmirutekat-llu.pdf',
  '8':'Autonomy_In_Behavioral_Health_Care-Ellminek_Ataniuriyaraq_Ayuqucim_Calricaaraani.pdf',
  '9':'Stages_Of_Change-Cimirturallret.pdf',
  '10':'Finding_The_Right_Provider-Yuallerkaq_Assilriamek_Umyualiurtekamek.pdf',
}


let customFontFam = customFontFam3
let customTitleFontFam = customTitleFontFam3
let customFontFam2 = {fontFamily:customTitleFontFam3}
let letterbutton = {fontFamily:customFontFam3,paddingTop:'10px',paddingBottom:'10px',paddingRight:'14px',paddingLeft:'14px'}
const isFirefox = typeof InstallTrigger !== 'undefined';

if (isFirefox) {
  customFontFam = customFirefoxTitleFontFam
  customTitleFontFam = customFirefoxTitleFontFam
  customFontFam2 = {fontFamily:customFirefoxTitleFontFam}
  letterbutton = {fontFamily:customFirefoxTitleFontFam,paddingTop:'10px',paddingBottom:'10px',paddingRight:'14px',paddingLeft:'14px'}
}

class Printouts extends Component {
	constructor(props) {
		super(props);
    // console.log(props,props.location.state.currentCategory !== 'all')
		this.state = {
      copyClicked:false,
			// search: props.location.state === undefined || 'currentCategory' in props.location.state && props.location.state.currentCategory !== 'all' ? '' :props.location.state.history[0],
			// wordsList: props.location.state === undefined || 'currentCategory' in props.location.state && props.location.state.currentCategory !== 'all' ? [] : props.location.state.history[1],
      // activeTabIndex: props.location.state === undefined ? 0 : ('currentCategory' in props.location.state && props.location.state.currentCategory !== 'all' ? 3 : props.location.state.history[3]),
      // homeMode: props.location.state === undefined ? 0 : ('currentCategory' in props.location.state && props.location.state.currentCategory !== 'all' ? 3 : props.location.state.history[3]),
      // tabValue: props.location.state === undefined ? 0 : ('currentCategory' in props.location.state && props.location.state.currentCategory !== 'all' ? 3 : props.location.state.history[3]),
      // activeAudioIndex: props.location.state === undefined || 'currentCategory' in props.location.state && props.location.state.currentCategory !== 'all' ? {} : props.location.state.history[4],

      // parseIndex:0,
      // playingAudio: false,
      // prevSearch: [],
      // prevWordsList: [],
      // logoup:false,

      // currentCategory: props.location.state === undefined ? 'all' :('currentCategory' in props.location.state && props.location.state.currentCategory !== 'all' ? props.location.state.currentCategory:'all'),
      // childrenCategories:[],
      // parentCategories:[],

      // categoriesDisplayed:[],
      // // combinedAudio:[],

      // useExample:true,
      // useConversational:true,
      // usePhrasebook:true,
      // audioFilterChangeable:true,

      // seeMoreAcknowledgments:false,
		}
    // console.log('new')
		this.handleRef = createRef()
		// this.handleRef2 = createRef()

    if (props.location.state !== undefined && 'history' in props.location.state) {
      // console.log('hi',props.location.state.history[2])
      scroll.scrollTo(props.location.state.history[2]);
    }
	}

  
	render() {
    let paddingtext = 15
		return (
			<div className="app" style={{fontFamily:customFontFam}}>
        <Grid textAlign='center'>
        <Grid.Row>
        <Grid.Column style={{ maxWidth: 800 }} textAlign='left'>    

          <Link to={{pathname: "/appendix"}} >
            <Button basic style={{paddingLeft:'10px',paddingRight:'15px',marginBottom:'3px'}} icon='left chevron' content='Back to List of Appendices' />
          </Link>
            
         <div style={{fontFamily:customTitleFontFam,marginBottom:20,marginTop:'30px',fontSize:'18px',fontWeight:'700'}}>Printable Reports:</div>
        <List>
          {Object.keys(pdfLinks).map((r)=> 
            <List.Item style={{margin:'25px 0px'}}>
              <span style={{color:'#4A80B5',cursor:'pointer',fontStyle:'italic',fontSize:'16px',lineHeight:'20px'}}><a style={{color:'#4a80b5'}} href={"/"+pdfLinks[r]} target="_blank" >{this.props.resourceIDs[r][0][0]+' - '+this.props.resourceIDs[r][1][0]+' (2025)'}</a></span>
            </List.Item>            
          )}
        </List>

        <Grid style={{fontSize:'15px'}}>
        <Grid.Row style={{marginTop:14,marginBottom:14}}>
        <Grid.Column>
        <Citation />
        </Grid.Column>
        </Grid.Row>
        </Grid>
        
        </Grid.Column>
        </Grid.Row>
        </Grid>

			</div>
		);
	}
}
export default Printouts;